import React, { useState, useEffect } from 'react';
import { API_URL, COLORS } from '../config';
import './UserProfile.css';

function UserProfile({ user, onClose, onMessage, onAddFriend, token, friends = [] }) {
  const [userDetails, setUserDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  
  // Check if user is already a friend
  const isFriend = friends.some(friend => friend.id === user.id);

  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const response = await fetch(`${API_URL}/api/users/${user.id}/profile`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        if (response.ok) {
          const data = await response.json();
          setUserDetails(data);
        }
      } catch (error) {
        console.error('Error fetching user details:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserDetails();
  }, [user.id, token]);

  const handleBackdropClick = (e) => {
    if (e.target.classList.contains('user-profile-backdrop')) {
      onClose();
    }
  };

  return (
    <div className="user-profile-backdrop" onClick={handleBackdropClick}>
      <div className="user-profile-modal">
        <button className="user-profile-close" onClick={onClose}>×</button>
        
        <div className="user-profile-banner" style={{ backgroundColor: COLORS.PRIMARY }}></div>
        
        <div className="user-profile-content">
          <div className="user-profile-avatar-container">
            {userDetails?.avatar_url ? (
              <img 
                src={`${API_URL}${userDetails.avatar_url}`} 
                alt="Avatar" 
                className="user-profile-avatar"
              />
            ) : (
              <div className="user-profile-avatar">
                {user.username?.[0]?.toUpperCase() || '?'}
              </div>
            )}
          </div>

          <div className="user-profile-info">
            <div className="user-profile-username">{user.username}</div>
            {userDetails?.status && (
              <div className="user-profile-status">
                <span className={`status-indicator ${userDetails.status}`}></span>
                {userDetails.status}
              </div>
            )}
          </div>

          {loading ? (
            <div className="user-profile-loading">Loading...</div>
          ) : (
            <>
              {userDetails?.bio && (
                <div className="user-profile-section">
                  <div className="user-profile-section-title">ABOUT ME</div>
                  <div className="user-profile-section-content">{userDetails.bio}</div>
                </div>
              )}

              {userDetails?.roles && userDetails.roles.length > 0 && (
                <div className="user-profile-section">
                  <div className="user-profile-section-title">ROLES</div>
                  <div className="user-profile-roles">
                    {userDetails.roles.map((role, idx) => (
                      <div 
                        key={idx}
                        className="user-profile-role"
                        style={{ 
                          backgroundColor: role.color ? `${role.color}20` : '#40444b',
                          borderLeft: `3px solid ${role.color || '#72767d'}`
                        }}
                      >
                        {role.name}
                      </div>
                    ))}
                  </div>
                </div>
              )}

              <div className="user-profile-section">
                <div className="user-profile-section-title">MEMBER SINCE</div>
                <div className="user-profile-section-content">
                  {userDetails?.created_at 
                    ? new Date(userDetails.created_at).toLocaleDateString('en-US', { 
                        year: 'numeric', 
                        month: 'long', 
                        day: 'numeric' 
                      })
                    : 'Unknown'}
                </div>
              </div>
            </>
          )}

          <div className="user-profile-actions">
            <button className="user-profile-action-btn primary" onClick={() => { onMessage(user.id); onClose(); }}>
              💬 Send Message
            </button>
            {!isFriend && (
              <button className="user-profile-action-btn secondary" onClick={() => { onAddFriend(user.id); onClose(); }}>
                ➕ Add Friend
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserProfile;
